export const getCookie = (cookieName) => {
  let value = `; ${document.cookie}`;
  let parts = value.split(`; ${cookieName}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
};

export async function fetchAbstract(
  url,
  apiKeyPos,
  params = {
    headers: { "content-type": "application/json", apikey: apiKeyPos },
    method: "GET",
    credentials: "include",
  }
) {
  try {
    const result = await fetch(url, params);
    if (!result.ok) {
      throw new Error("HTTP status " + result.status);
    }
    return Promise.resolve(result.json());
  } catch (error) {
    return Promise.reject(error);
  }
}
